/** 댓글에서 언급(@아이디)된 사용자 */
export interface CommentMention {
  username: string
  userId: string
  nickname: string
}

export interface ReviewComment {
  id: string
  user: {
    nickname: string
    username?: string | null
    profileImage?: string
  }
  userId?: string | null
  text: string
  likes: number
  isLiked?: boolean
  parentCommentId?: string
  /** 서버가 실제 언급으로 인정한 아이디들 (이 목록에 있는 것만 강조된다) */
  mentions?: CommentMention[]
}

/** 댓글 작성자 표시: 로그인 아이디(username) 우선, 없으면 닉네임 */
export function getCommentAuthorDisplay(
  user: ReviewComment['user']
): string {
  const id = user.username?.trim()
  if (id) {
    return id
  }

  return user.nickname
}
